import { render, staticRenderFns } from "./FormControlAccountSettingsPrimaryDomain.vue?vue&type=template&id=d13054a6&scoped=true"
import script from "./FormControlAccountSettingsPrimaryDomain.vue?vue&type=script&setup=true&lang=js"
export * from "./FormControlAccountSettingsPrimaryDomain.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FormControlAccountSettingsPrimaryDomain.vue?vue&type=style&index=0&id=d13054a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d13054a6",
  null
  
)

export default component.exports